export class Globals {
     static webUrl = '/api/';
    // static webUrl = 'http://localhost:64774/api/';
    static refreshTime = 15;
}
